module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 142.41690382.png";